import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { informarIngreso } from "../../redux/actions";
import Button from "../../components/button";

function InformarIngresoComponent({ onCloseInformar, actasJuzgado, openSuccessModal, openErrorModal }) {
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.currentUserId);
    const [loading, setLoading] = useState(false);
    const [selectedActa, setSelectedActa] = useState(null);

    const onSubmit = async () => {
        setLoading(true);
        const info = {
            userId,
            actaId: selectedActa.id,
            nroActa: selectedActa.nro,
        };
        try {
            await dispatch(informarIngreso(info));
            openSuccessModal()
        } catch (error) {
            console.error("Error al intentar informar ingreso", error);
            openErrorModal(error.message);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 "
            onClick={onCloseInformar} /* Cierra al hacer clic fuera */
        >
            <div
                className="w-[20rem] sm:w-[30rem] px-5 py-8 bg-white rounded-xl flex flex-col justify-center  mx-5 overflow-y-auto my-[2rem]"
                onClick={(e) =>
                    e.stopPropagation()
                } /* Evita que el clic dentro lo cierre */
            >
                {/* Título */}
                <div className="sm:text-left text-center text-[#3d4245] text-2xl font-bold font-inter">
                    Seleccione el número de acta que ya ingresó para informar a juzgado
                </div>

                <div className="flex flex-wrap justify-center gap-5 my-[2rem]  w-[18rem] sm:w-[26rem]">
                    {actasJuzgado.map((acta) =>
                        <button
                            onClick={() => setSelectedActa({ id: acta.id, nro: acta.nroActa })}
                            key={acta.id}
                            className={`inline-flex items-center rounded-md bg-[#F5FAFF] px-2 py-1 text-3xl font-medium text-[#0477ad] ring-1 ring-[#0477ad] ring-inset
                            ${selectedActa?.id === acta.id
                                    ? "bg-[#F5FAFF] text-[#0477ad] ring-[#0477ad]"
                                    : "bg-gray-100 text-gray-600 ring-gray-400"
                                }`}
                        >
                            {acta.nroActa}
                        </button>
                    )}
                </div>



                {/* Botones */}
                <div className="self-stretch flex justify-start items-start gap-3 sm:flex-row flex-col pb-5">
                    <Button
                        size="lg"
                        fullWidth
                        loading={loading}
                        disabled={!selectedActa || loading}
                        onClick={onSubmit}
                    >
                        Informar
                    </Button>
                    <Button
                        variant="secondary"
                        size="lg"
                        fullWidth
                        onClick={onCloseInformar}
                        className="sm:mb-0 mb-5"
                    >
                        Cancelar
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default InformarIngresoComponent;
